import React from 'react'

import { Button } from '@st-operations/uikit/src/v2/index.js'
import { useEventFeedsContext } from '../../../context/index.jsx'

const GenerateS3KeysButton = ({ onClick }) => {
  const {
    data: { deliveries },
  } = useEventFeedsContext()
  const delivery = deliveries[0] ?? {}

  if (delivery.destination != 'sharethis-s3' || !delivery.name) return null

  let keys = null
  if (delivery.s3AccessKeys)
    delivery.s3AccessKeys.forEach((_keys) => {
      if (_keys.name == delivery.name && _keys.accessKey) {
        keys = _keys
      }
    })

  if (keys) {
    return null
  }

  return (
    <Button className="delivery-content__footer-button" onClick={onClick}>
      Generate S3 Keys
    </Button>
  )
}

export default GenerateS3KeysButton
